import dayjs from 'dayjs'

export const timeUtil = {
  getDateTimeFullPayload(date) {
    const $date = dayjs(date)
    const isDateOfValid = $date.isValid()
    if (!isDateOfValid) {
      return {
        year: '',
        date: '',
        weekday: '',
      }
    }
    return {
      year: $date.format('YYYY'),
      date: $date.format('MM/DD HH:mm'),
      weekday: $date.day(),
    }
  },
  formatDateTime(date, utc = false) {
    const dayjsDate = utc ? dayjs.utc(date).local() : dayjs(date)
    return dayjsDate.isValid() ? dayjsDate.format('YYYY/MM/DD HH:mm') : ''
  },
  formatEndTimeValue(value, utc = false) {
    return timeUtil.formatDateTime(value, utc) || value
  },
  formatDate(date, utc = false, format = 'YYYY/MM/DD') {
    const dayjsDate = utc ? dayjs.utc(date).local() : dayjs(date)
    return dayjsDate.isValid() ? dayjsDate.format(format) : ''
  },
  formatWeekDateHelper(dateTime) {
    const $date = dayjs(dateTime)
    const month = $date.month() + 1
    const date = $date.date()
    const day = $date.day()
    return { month, date, day }
  },
  isSameDate(date1, date2) {
    const $date1 = dayjs(date1)
    const $date2 = dayjs(date2)
    return $date1.isValid() && $date2.isValid() && $date1.isSame($date2, 'day')
  },
  isSame(date1, date2, unit = 'minute') {
    const $date1 = dayjs(date1)
    const $date2 = dayjs(date2)
    return $date1.isValid() && $date2.isValid() && $date1.isSame($date2, unit)
  },
  formatBookingTimeAsOriginal(originalBookingTime, targetDateTime) {
    const isUnixSecondsTimestamp = /^\d{10}$/.test(originalBookingTime)
    return isUnixSecondsTimestamp ? String(targetDateTime.unix()) : targetDateTime.format('YYYY-MM-DD HH:mm:ss')
  },
  parseUnixTime(unixTime) {
    return /^\d{10}$/.test(unixTime) ? dayjs.unix(Number(unixTime)) : dayjs(unixTime)
  },
}
